import { ButtonContentLink } from 'fukku/Button/ContentLink'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useDownloadReturnsPdf } from 'my-purchases/hooks/useDownloadReturnsPdf/useDownloadReturnsPdf'
import type { OrderDetails } from 'my-purchases/types/purchaseDetail'
import {
	sendOnDownloadForm,
	sendOnDownloadLabel,
} from 'my-purchases/utils/analytics/analyticsEvents'

import styles from './ReturnsDownloadForm.module.scss'

export function ReturnsDownloadForm({
	order,
}: {
	readonly order: OrderDetails
}) {
	const { t } = useLabels()
	const { downloadReturnsPdf } = useDownloadReturnsPdf()
	const { billing, id, detailOperations } = order
	const { returnForm, returnLabel } = detailOperations ?? {}

	if (!returnForm) {
		return null
	}

	const downloadPdf = (path: string, pdfName: string) =>
		downloadReturnsPdf({ path, pdfName, billingEmail: billing?.email })

	const downloadLabel = (e: React.MouseEvent<HTMLButtonElement>) => {
		if (!returnLabel) {
			return
		}
		e.preventDefault()
		sendOnDownloadLabel()
		downloadPdf(returnLabel, `${id}-return-label.pdf`)
	}

	const downloadForm = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault()
		sendOnDownloadForm()
		downloadPdf(returnForm, `${id}-return-form.pdf`)
	}

	return returnLabel ? (
		<div className={styles.container}>
			<p className={styles.description}>
				{t('myPurchases.online.details.returns.returnForm.withLabel.bodycopy')}
			</p>
			<div className={styles.linksWrapper}>
				<ButtonContentLink
					data-testid='myPurchases.returns.downloadForm.link'
					className={styles.downloadFormBtn}
					onClick={downloadForm}
				>
					{t('myPurchases.online.details.returns.downloadForm.link')}
				</ButtonContentLink>
				<div className={styles.divider}>|</div>
				<ButtonContentLink
					data-testid='myPurchases.returns.downloadLabel.link'
					onClick={downloadLabel}
				>
					{t('myPurchases.online.details.returns.downloadLabel.link')}
				</ButtonContentLink>
			</div>
		</div>
	) : (
		<div className={`${styles.container} ${styles.row}`}>
			<p className={styles.description}>
				{t('myPurchases.online.details.returns.returnForm.noLabel.bodycopy')}
			</p>
			<ButtonContentLink
				data-testid='myPurchases.returns.downloadForm.link'
				onClick={downloadForm}
			>
				{t('myPurchases.online.details.returns.downloadForm.link')}
			</ButtonContentLink>
		</div>
	)
}
